import type { Model } from '@patsnap/tahiti-core/common/model';
import type { TranslationOptions } from '../types';

export const TranslationOptionModel = Symbol.for('TranslationOptionModel');

export interface TranslationOptionModel extends Model<TranslationOptions> {}
